export default {"src":"/login-app/[GIT_HASH]/_next/static/media/ms_teams.49668c6b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};